import React from 'react';
import { DatePicker } from '@material-ui/pickers';
import { TextField } from '@material-ui/core';
import moment from '../../moment-hawaii';

const PriceRuleDateRange = ({ value, setValue, label, format, minDate, maxDate }) => (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {value.map((val, key) => (
            <DatePicker
                key={key}
                variant="inline"
                style={{ marginRight: '0.5rem' }}
                label={label}
                autoOk
                disableToolbar
                minDate={moment(minDate, format)}
                maxDate={moment(maxDate, format)}
                value={moment(val, format)}
                onChange={date =>
                    setValue(value.map((d, k) => (k === key ? date.format(format) : d)))
                }
                renderInput={props => <TextField {...props} helperText={null} />}
            />
        ))}
    </div>
);

export default PriceRuleDateRange;
